import { AgeType } from "types/code-generator";

export default (offering: {
  minAge: number;
  maxAge: number;
  minAgeType: string;
  maxAgeType: string;
}) => {
  let agesString = "";

  if (!offering) {
    return agesString;
  }

  const { minAge, maxAge, minAgeType, maxAgeType } = offering;

  let minAgeString = minAge && minAge.toString();
  let maxAgeString = maxAge && maxAge.toString();

  if (minAgeType === AgeType.Month || maxAgeType === AgeType.Month) {
    minAgeString = `${minAge} ${minAgeType === "Month" ? "mo" : "yr"}`;
    maxAgeString = `${maxAge} ${maxAgeType === "Month" ? "mo" : "yr"}`;
  }

  if ((minAge === 0 && maxAge === 99) || (!minAge && !maxAge)) {
    agesString = "All Ages";
  } else if (minAge && !maxAge) {
    agesString = `Ages ${minAgeString} & Up`;
  } else if (maxAge && !minAge) {
    agesString = `Ages ${maxAgeString} & Under`;
  } else if (maxAge === minAge && maxAgeType === minAgeType) {
    agesString = `Age ${minAgeString}`;
  } else if (maxAge !== 0 && minAge !== 99) {
    agesString = `Ages ${minAgeString}–${maxAgeString}`;
  }

  return agesString;
};
